import React, { Component } from "react";
import PhotographerGallery from "../components/photographerGallery";
import { photographers } from "../data/photographers.js";

function getPhotographerName(id) {
  var photographerIdToNameMap = {};

  photographers.forEach(x => {
    var photographerId = x
      .toLowerCase()
      .replace(" ", "_")
      .replace("-", "_");
    photographerIdToNameMap[photographerId] = x;
  });

  return photographerIdToNameMap[id];
}

class Gallery extends Component {
  constructor() {
    super();
    this.state = {
      photographerId: ""
    };
  }

  componentDidMount() {
    var photographerId = this.props.match.params.photographerId;

    this.setState({ photographerId: photographerId });
  }

  render() {
    var { photographerId } = this.state;

    if (photographerId === "") {
      return null;
    }

    var name = getPhotographerName(photographerId);

    return (
      <div className="container galleryContainer">
        <h1>{name}</h1>
        <PhotographerGallery photographerId={photographerId} />
      </div>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/pages/gallery.jsx